<div class="column" [formGroup]="columnGroup">
  <div class="column__drag-drop"><span class="material-symbols-outlined">drag_indicator</span></div>
  <span class="column__name">{{ columnGroup.get('columnKey')?.value | columnNameByKey: type | async }}</span>
  @let columnType = columnGroup.get('columnKey')?.value | columnTypeByKey: type | async;
  @if (columnType === 'DateTime') {
    <mat-form-field subscriptSizing="dynamic">
      <mat-select [formControlName]="'columnFormatKey'">
        @for (option of columnType | columnDataFormats | async; track option.key) {
          <mat-option [value]="option.key">{{ option.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  } @else {
    <div class="column__empty-placeholder"></div>
  }
  <span class="material-symbols-outlined column__delete-icon" (click)="columnDeleted.emit()">delete</span>
</div>
